const PauseFillIcon = (props) => (
  <svg
    width={34}
    height={36}
    viewBox="0 0 34 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.27791 36C7.71107 36 6.24372 35.6222 4.95045 34.8665C1.89139 33.0782 0.200195 29.4762 0.200195 24.7409V11.2651C0.200195 6.52975 1.89139 2.92783 4.95045 1.13947C8.00952 -0.6489 11.9142 -0.321453 15.9929 2.04624L27.508 8.77151C31.5618 11.1392 33.8002 14.4137 33.8002 17.9904C33.8002 21.5671 31.5618 24.8416 27.508 27.2093L15.9929 33.9346C13.6551 35.3199 11.367 36 9.27791 36ZM9.27791 3.78423C8.35771 3.78423 7.51211 3.98574 6.79087 4.41394C4.95045 5.49703 3.93077 7.9151 3.93077 11.2651V24.7157C3.93077 28.0405 4.95045 30.4838 6.81574 31.5669C8.68102 32.65 11.2676 32.3225 14.1277 30.6601L25.6427 23.9348C28.5028 22.2724 30.0696 20.1566 30.0696 17.9904C30.0696 15.8242 28.5028 13.7084 25.6427 12.046L14.1277 5.32071C12.3619 4.288 10.7204 3.78423 9.27791 3.78423Z"
      fill="currentColor"
    />
    <path
      d="M30.2 13.2L11 2.40002C5.71996 2.40002 3.19995 5.60002 2.59995 7.20002C2.79995 11.2 3.07995 20.64 2.59995 26.4C2.11995 32.16 7.99995 34.4 11 34.8C13 32.8 18.68 28.32 25.4 26.4C32.12 24.48 31.4 16.8 30.2 13.2Z"
      fill="currentColor"
    />
  </svg>
);
export default PauseFillIcon;
